module.exports = __webpack_public_path__ + "img/breakfast_bistro_menu4.366ced76.png";